jQuery(document).ready(function ($) {
  console.log('Sleepless Initialized');
  console.log(cartData);

  var cartOpen = false;
  var extendRendered = false;

  function getCartData(){
    var cartContents = fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(data => { return data });
    return cartContents;
  }
  
  function onCartChange(){
    getCartData().then(function(value) {
      // Add or remove the gift-with-purchase line first (free-gift.js)
      return window.ikGiftSync ? window.ikGiftSync(value) : value;
    }).then(
      function(value) {
        cartData = { ...value }; //shallow copy
        console.log(cartData);
        //what to do with new cart content goes here
        renderCart();
        var newQty = cartData.item_count * 1;
        var itemText = " item";
        if (newQty > 1){
          itemText = " items";
        }
        $('.cart-count-bubble').find('span[aria-hidden]').text(newQty);
        $('.cart-count-bubble').find('span.visually-hidden').text(newQty + itemText);
        openCart();
      }
    );
  }

  function formatPrice(numInCents) {
    // Convert cents to dollars and force exactly two decimals
    let str = (numInCents / 100).toFixed(2);
  
    // Insert commas into the integer part
    str = str.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  
    // Finally, prepend the dollar sign
    return '$' + str;
  }

  var cartItemTemplate = $('.minicartItem').clone(false);
  $('.minicart__itemList').html('');

  function announceQty(card, qty) {
    var name = (card.find('.minicartItem__title').text() || 'Item').trim();
    var liveElement = card.find('.minicartItem__live');

    liveElement.text(name + ' quantity is now ' + qty + '.');

    setTimeout(function() {
      liveElement.text('');
    }, 1000);
  }

  function announceRemove(card) {
    var name = (card.find('.minicartItem__title').text() || 'Item').trim();
    var liveElement = card.find('.minicartItem__live');
    
    liveElement.text(name + ' removed from cart.');
    
    setTimeout(function() {
      liveElement.text('');
    }, 1000);
  }

  function renderCart(){
    var items = cartData.items;
    var subtotal = cartData.items_subtotal_price;
    $('.minicart__itemList').html('');
    for (i=0;i<items.length;i++){
      var itemHTML = cartItemTemplate.clone(false);
      itemHTML.attr('data-index', items[i].key);
      itemHTML.attr('data-id', items[i].id)
      itemHTML.attr('data-variant', items[i].variant_id)
      itemHTML.find('.minicartItem__image').attr('src', items[i].featured_image.url);
      itemHTML.find('.minicartItem__image').attr('alt', items[i].featured_image.alt);
      itemHTML.find('.minicartItem__title').text(items[i].product_title);
      if (items[i].options_with_values[0].value != "Default Title" && items[i].options_with_values[0].value != "Default"){
        var optionText = "";
        for (j=0;j<items[i].options_with_values.length;j++){
          optionText += items[i].options_with_values[j].value;
          if (j < items[i].options_with_values.length){
            optionText += '</br>';
          }
        }
        itemHTML.find('.minicartItem__options').html(optionText);
      }
      else{
        itemHTML.find('.minicartItem__options').hide();
      }
      
      itemHTML.find('.minicartItem__qty').val(items[i].quantity);
      var isGiftLine = items[i].properties && items[i].properties._gift;
      if (isGiftLine){
        // Gift with purchase: no quantity controls, show the label and the discounted price
        itemHTML.addClass('minicartItem--gift');
        itemHTML.find('.minicartItem__qtyWrapper, .minicartItem__remove').hide();
        var giftLabel = (window.ikGift && window.ikGift.label) || 'Free gift';
        itemHTML.find('.minicartItem__options').show().text(giftLabel);
      }
      if (items[i].final_line_price < items[i].original_line_price){
        itemHTML.find('.minicartItem__price').html(
          '<s class="minicartItem__was">' + formatPrice(items[i].original_line_price) + '</s> ' +
          (items[i].final_line_price === 0 ? 'Free' : formatPrice(items[i].final_line_price))
        );
      }
      else{
        itemHTML.find('.minicartItem__price').text(formatPrice(items[i].price));
      }
      $('.minicart__itemList').append(itemHTML);
    }
    
    $('.minicart__subtotal').text(formatPrice(subtotal));
    $('.minicart__affirmWrapper .affirm-as-low-as').attr('data-amount', subtotal);
    affirm.ui.refresh();

    $('.minicartItem__minus').on('click', function(){
      var card = $(this).closest('.minicartItem');
      var key = card.attr('data-index');
      var oldQty = card.find('.minicartItem__qty').val() * 1;
      var newQty = oldQty - 1;
      if (newQty > 0){
        card.find('.minicartItem__qty').val(newQty);
        announceQty(card, newQty);
        updateLineItem(key, newQty);
        
      }
    });
    
    $('.minicartItem__plus').on('click', function(){
      var card = $(this).closest('.minicartItem');
      var key = card.attr('data-index');
      var oldQty = card.find('.minicartItem__qty').val() * 1;
      var newQty = oldQty + 1;

      card.find('.minicartItem__qty').val(newQty);
      announceQty(card, newQty);
      updateLineItem(key, newQty);

    });
    
    $('.minicartItem__remove').on('click', function(){
      var card = $(this).closest('.minicartItem');
      var key = card.attr('data-index');
      var oldQty = card.find('.minicartItem__qty').val() * 1;
      var newQty = 0;

      card.slideUp();
      announceRemove(card);
      updateLineItem(key, newQty)
    });
  }

  function updateLineItem(key, newQty){
    var update = {
      id: key,
      quantity: newQty
    };

    jQuery.ajax({
      type:'post',
      url:'/cart/change.js',
      data:update,
      dataType:'json',
      success:function(result){
        console.log(result);
        onCartChange();
      },
      error:function(result){
        console.error(result);
      }
    });
  }

  function openCart(){
    cartOpen = true;
    var minicart = $('#minicart');
    $('body, html').addClass('noScroll');
    minicart.show();
    $('.minicart__overlay').show();
    $('.pdpMobileStickyBuy').hide();
  }

  function closeCart(){
    cartOpen = false;
    var minicart = $('#minicart');
    $('body, html').removeClass('noScroll');
    minicart.hide();
    $('.minicart__overlay').hide();
    $('.pdpMobileStickyBuy').show();
  }

  $('.minicart__overlay').on('click', function(){
    closeCart();
  });

  var cartCheck = setInterval(function(){
    if (!$('#cart-notification').hasClass('active')){
      return false
    }

    onCartChange();
    $('#cart-notification').removeClass('active')
  }, 100)

  $('.minicart__close').on('click', function(){
    closeCart();
  });

  $('.header__icon--cart').on('click', function(e){
    e.preventDefault();
    if (!$(this).hasClass('disabled-cart-button')){
      renderCart();
      openCart();
    }
  });

    var swiperLib = [];
    var arrayIndex = 0;
    $('.swiper-wrapper').each(function(){
  
      var origin = $(this).closest('[data-builder-index]');
      var builderIndex = origin.attr('data-builder-index');
      
      if (origin.hasClass('borderHero')){
        swiperLib.push(new Swiper('[data-builder-index="'+builderIndex+'"] .borderHero__slider', {
          autoplay: {
            delay: 5000,
          },
          loop: true
        }));
  
        $('[data-builder-index="'+builderIndex+'"] .borderHero__pauseButton').attr('data-array-index', arrayIndex);
        
        $('[data-builder-index="'+builderIndex+'"] .borderHero__pauseButton').on('click', function(){
          var thisIndex = $(this).attr('data-array-index') * 1;
          console.log(swiperLib[thisIndex]);
          swiperLib[thisIndex].autoplay.pause();
        });
        
        arrayIndex += 1;
      }
      else if (origin.hasClass('borderBanner--marquee')){
        swiperLib.push(new Swiper('[data-builder-index="'+builderIndex+'"] .borderBanner__slider', {
          loop: false,
          navigation: {
            prevEl: '[data-builder-index="'+builderIndex+'"] .borderBanner__prev',
            nextEl: '[data-builder-index="'+builderIndex+'"] .borderBanner__next'
          }
        }));
  
        arrayIndex += 1;
      }
      else if (origin.hasClass('prodCarousel')){
        swiperLib.push(new Swiper('[data-builder-index="'+builderIndex+'"] .prodCarousel__slider', {
          loop: false,
          slidesPerView: 1,
          spaceBetween: 25,
          navigation: {
            prevEl: '[data-builder-index="'+builderIndex+'"] .prodCarousel__sliderPrev',
            nextEl: '[data-builder-index="'+builderIndex+'"] .prodCarousel__sliderNext'
          },
          scrollbar: {
            el: '[data-builder-index="'+builderIndex+'"] .prodCarousel__bar',
            draggable: true
          },
          breakpoints: {
            600: {
              slidesPerView: 2
            },
            800: {
              slidesPerView: 3
            },
            1000: {
              slidesPerView: 4
            }
          }
        }));
  
        arrayIndex += 1;
      }
      else if (origin.hasClass('buildGallery')){
        swiperLib.push(new Swiper('[data-builder-index="'+builderIndex+'"] .buildGallery__slider', {
          loop: false,
          slidesPerView: 1,
          spaceBetween: 25,
          navigation: {
            prevEl: '[data-builder-index="'+builderIndex+'"] .buildGallery__prev',
            nextEl: '[data-builder-index="'+builderIndex+'"] .buildGallery__next'
          },
          scrollbar: {
            el: '[data-builder-index="'+builderIndex+'"] .buildGallery__bar',
            draggable: true
          }
        }));
  
        arrayIndex += 1;
      }
      else if (origin.hasClass('blogSlider')){
        swiperLib.push(new Swiper('[data-builder-index="'+builderIndex+'"] .blogSlider__slider', {
          loop: false,
          slidesPerView: 1,
          spaceBetween: 25,
          breakpoints: {
            600: {
              slidesPerView: 2
            },
            800: {
              slidesPerView: 3
            }
          },
          navigation: {
            prevEl: '[data-builder-index="'+builderIndex+'"] .blogSlider__sliderPrev',
            nextEl: '[data-builder-index="'+builderIndex+'"] .blogSlider__sliderNext'
          },
          scrollbar: {
            el: '[data-builder-index="'+builderIndex+'"] .blogSlider__bar',
            draggable: true
          }
        }));
  
        arrayIndex += 1;
      }
      else if (origin.hasClass('blogSlider--collections')){
        swiperLib.push(new Swiper('[data-builder-index="'+builderIndex+'"] .blogSlider__slider', {
          loop: false,
          slidesPerView: 1,
          spaceBetween: 20,
          breakpoints: {
            600: {
              slidesPerView: 2
            },
            800: {
              slidesPerView: 4
            }
          },
          navigation: {
            prevEl: '[data-builder-index="'+builderIndex+'"] .blogSlider__sliderPrev',
            nextEl: '[data-builder-index="'+builderIndex+'"] .blogSlider__sliderNext'
          },
          scrollbar: {
            el: '[data-builder-index="'+builderIndex+'"] .blogSlider__bar',
            draggable: true
          }
        }));
  
        arrayIndex += 1;
      }
      else if (origin.hasClass('featsBlade')){
        swiperLib.push(new Swiper('[data-builder-index="'+builderIndex+'"] .featsBlade__sliderWrapper', {
          loop: false,
          slidesPerView: 1,
          navigation: {
            prevEl: '[data-builder-index="'+builderIndex+'"] .featsBlade__prev',
            nextEl: '[data-builder-index="'+builderIndex+'"] .featsBlade__next'
          }
        }));
  
        arrayIndex += 1;
      }
      else if (origin.hasClass('videoGallery')){
        swiperLib.push(new Swiper('[data-builder-index="'+builderIndex+'"] .mobVidGal__swiperWrapper', {
          loop: false,
          slidesPerView: 1,
          scrollbar: {
            el: '[data-builder-index="'+builderIndex+'"] .mobVidGal__dots',
            draggable: true
          }
        }));
  
        arrayIndex += 1;
      }
      
    });

    $('.borderBanner__watchButton').on('click', function(){
      console.log('clicked');
      var thisParent = $(this).closest('[data-builder-index]').parent();
      var videoSrc = $(this).attr('data-iframe-src');
      thisParent.find('.vidPopup').fadeIn();
      thisParent.find('.vidPopup__iframe').attr('src', videoSrc);
    });
  
    $('.vidPopup__background, .vidPopup__close').on('click', function(){
      var thisPopup = $(this).closest('.vidPopup');
      thisPopup.fadeOut();
      thisPopup.find('.vidPopup__iframe').attr('src', '');
    });
  
    $('.buildGallery__mobileHiddenSeeMore').on('click', function(){
      $('.buildGallery__mobileHiddenLinks').slideDown();
      $(this).hide();
    });

    $('.oneColumnAccord__accordionButton').on('click', function(){
      var thisParent = $(this).parent();
      var thisSection = $(this).closest('.shopify-section');
      if (thisParent.hasClass('oneColumnAccordion__accordionWrapper--active')){
        thisParent.removeClass('oneColumnAccordion__accordionWrapper--active');
        thisParent.find('.oneColumnAccord__accordionShelf').slideUp();
      }
      else{
        thisSection.find('.oneColumnAccord__accordionWrapper').removeClass('oneColumnAccordion__accordionWrapper--active');
        thisSection.find('.oneColumnAccord__accordionWrapper').find('.oneColumnAccord__accordionShelf').slideUp();
        
        thisParent.addClass('oneColumnAccordion__accordionWrapper--active');
        thisParent.find('.oneColumnAccord__accordionShelf').slideDown();
      }
    });

    $('.videoGallery__navButton').on('click', function(){
      var thisParent = $(this).closest('.videoGallery__inner');
      var thisIndex = $(this).attr('data-index');
      thisParent.find('.videoGallery__navButton').removeClass('videoGallery__navButton--active');
      thisParent.find('.videoGalleryBox').removeClass('videoGalleryBox--active');

      $(this).addClass('videoGallery__navButton--active');
      thisParent.find('.videoGalleryBox[data-index="'+thisIndex+'"]').addClass('videoGalleryBox--active');
    });

    $('.videoGalleryBox__playButton').on('click', function(){
      console.log('test');
      var thisSection = $(this).closest('.shopify-section');
      var thisIframeID = $(this).attr('data-iframe');

      var popUp = thisSection.find('.videoGalleryPopup');
      popUp.find('.videoGallery__iframe').attr('src', thisIframeID);
      popUp.fadeIn();
    });

    $('.videoGallery__close, .videoGallery__background').on('click', function(){
      $('.videoGalleryPopup').fadeOut();
      $('.videoGallery__iframe').attr('src', '');
    });

  var productThumbSwiperData = {
    slidesPerView: 'auto',
    spaceBetween: 12,
    loop: false,
    direction: 'vertical',
    slidesOffsetAfter:0,
    slideToClickedSlide: false,
    navigation: {
      prevEl: '.pdp__thumbPrev',
      nextEl: '.pdp__thumbNext'
    },
    breakpoints: {
      1000: {
        slideToClickedSlide: true,
      }
    }
  };
  var productThumbSwiper = new Swiper('.pdp__thumbsWrapper', productThumbSwiperData);

  var productGallerySwiperData = {
    slidesPerView: 1,
    loop: false,
    thumbs: {
      swiper: productThumbSwiper,
    },
    navigation: {
      prevEl: '.pdp__sliderPrev',
      nextEl: '.pdp__sliderNext'
    },
    scrollbar: {
      el: '.pdp__GalleryDots',
      draggable: true
    }
  };
  var productGallerySwiper = new Swiper('.pdp__galleryWrapper', productGallerySwiperData);

  $('.pdpFeatured__infoPopupButton').on( "mouseenter", function(){
    $(this).parent().find('.pdpFeatured__infoPopupBox').fadeIn("fast", function(){});
  }).on( "mouseleave", function(){
    $(this).parent().find('.pdpFeatured__infoPopupBox').fadeOut("fast", function(){});
  });

  $('.pdp__optionButton--color').each(function(){
    var colorName = $(this).attr('data-name-handlized');
    console.log(colorName);
    var colorCode = colorLib[colorName];
    console.log(colorCode);
    $(this).attr("style", 'background-color: '+colorCode+';');
  });

  $('.pdp__optionButton').on('click', function(){
    $(this).parent().find('.pdp__optionButton--active').removeClass('pdp__optionButton--active');
    $(this).addClass('pdp__optionButton--active');
    $(this).closest('.pdp__optionWrapper').find('.pdp__activeOption').text($(this).attr('data-name'));
    updateSelectedPDPOptions();
  });

  $('.pdp__optionWrapper').each(function(){
    var newName = $(this).find('.pdp__optionButton--active').attr('data-name');
    $(this).find('.pdp__activeOption').text(newName);
  });

  
  
  function updateSelectedPDPOptions(){
    var optionOne = '';
    var optionTwo = '';
    var optionThree = '';
    if ($('.pdp__optionWrapper--1').length > 0){
      var optionVal = $('.pdp__optionWrapper--1 .pdp__optionButton--active').attr('data-name');
      optionOne = $('.pdp__optionWrapper--1 .pdp__optionButton--active').attr('data-name') || '';
      $('[sm-rc-option1-selector').val(optionVal).change();
    }
    if ($('.pdp__optionWrapper--2').length > 0){
      var optionVal = $('.pdp__optionWrapper--2 .pdp__optionButton--active').attr('data-name');
      optionTwo = $('.pdp__optionWrapper--2 .pdp__optionButton--active').attr('data-name') || '';
      $('[sm-rc-option2-selector').val(optionVal).change();
    }
    if ($('.pdp__optionWrapper--3').length > 0){
      var optionVal = $('.pdp__optionWrapper--3 .pdp__optionButton--active').attr('data-name');
      optionThree = $('.pdp__optionWrapper--3 .pdp__optionButton--active').attr('data-name') || '';
      $('[sm-rc-option3-selector').val(optionVal).change();
    }

    var newImage = $('[sm-rc-variant-selector]').find(":selected").attr('data-image');

    if ($('.pdp__thumbsWrapper').find('.pdp__thumbnailImage[src="'+newImage+'"]').first().closest('.pdp__thumbnail').length){
      var slideIndexString = $('.pdp__thumbsWrapper').find('.pdp__thumbnailImage[src="'+newImage+'"]').first().closest('.pdp__thumbnail').attr('aria-label');
      if (slideIndexString.indexOf(" / ") != -1){
        var slideIndex = slideIndexString.split(' / ')[0] - 1;
        productThumbSwiper.slideTo(slideIndex, 200, false)
        productGallerySwiper.slideTo(slideIndex, 200, false)
      }
    }
    else{
      console.log('cannot find thumb to switch')
    }

    // Clear old state
    $('.pdp__optionButton').removeClass('pdp__optionButton--oos');

    var $variants = $('[sm-rc-variant-selector]').find('option');

    // Helper: does there exist an AVAILABLE variant that matches these 3 values?
    function hasAvailableVariant(o1, o2, o3) {
      var found = false;

      $variants.each(function () {
        var $v = $(this);

        if (
          (!o1 || $v.attr('data-option-1') === o1) &&
          (!o2 || $v.attr('data-option-2') === o2) &&
          (!o3 || $v.attr('data-option-3') === o3) &&
          $v.attr('data-available') === 'true'
        ) {
          found = true;
          return false; // break
        }
      });

      return found;
    }

    // ---------- OPTION 1 BUTTONS (e.g. Size) ----------
    if ($('.pdp__optionWrapper--1').length > 0) {
      $('.pdp__optionWrapper--1 .pdp__optionButton').each(function () {
        var $btn = $(this);
        var val = $btn.attr('data-name');

        var possible = hasAvailableVariant(
          val,                 // pretend we pick this size
          optionTwo || '',     // keep current color (if any)
          optionThree || ''    // keep current third option (if any)
        );

        $btn.toggleClass('pdp__optionButton--oos', !possible);
      });
    }

    // ---------- OPTION 2 BUTTONS (e.g. Color) ----------
    if ($('.pdp__optionWrapper--2').length > 0) {
      $('.pdp__optionWrapper--2 .pdp__optionButton').each(function () {
        var $btn = $(this);
        var val = $btn.attr('data-name');

        var possible = hasAvailableVariant(
          optionOne || '',     // keep current size (if any)
          val,                 // pretend we pick this color
          optionThree || ''    // keep current third option (if any)
        );

        $btn.toggleClass('pdp__optionButton--oos', !possible);
      });
    }

    // ---------- OPTION 3 BUTTONS (if you use them) ----------
    if ($('.pdp__optionWrapper--3').length > 0) {
      $('.pdp__optionWrapper--3 .pdp__optionButton').each(function () {
        var $btn = $(this);
        var val = $btn.attr('data-name');

        var possible = hasAvailableVariant(
          optionOne || '',
          optionTwo || '',
          val                 // pretend we pick this 3rd option
        );

        $btn.toggleClass('pdp__optionButton--oos', !possible);
      });
    }

    console.log(extendRendered);
    if (extendRendered){
      changeExtend();
      $('.pdp__extendWrapper').addClass('pdp__extendWrapper--rendered');
    }
  }

  updateSelectedPDPOptions();

  $('.pdp__accordionHead').on('click', function(){
    $(this).parent().toggleClass('pdp__accordionWrapper--open');
    $(this).parent().find('.pdp__accordionBody').slideToggle();
  });

  $('.buildFaq__accordionHeader').on('click', function(){
    var thisParent = $(this).parent();
    var thisSection = $(this).closest('.buildFaq__column');
    if (thisParent.hasClass('buildFaq__accordionWrapper--active')){
      thisParent.removeClass('buildFaq__accordionWrapper--active');
      thisParent.find('.buildFaq__accordionBody').slideUp();
    }
    else{
      thisSection.find('.buildFaq__accordionWrapper').removeClass('buildFaq__accordionWrapper--active');
      thisSection.find('.buildFaq__accordionWrapper').find('.buildFaq__accordionBody').slideUp();
      
      thisParent.addClass('buildFaq__accordionWrapper--active');
      thisParent.find('.buildFaq__accordionBody').slideDown();
    }
  });

  
  function renderExtend(){
    try {
      var variantID = $('[sm-rc-variant-selector]').find(":selected").attr('value');
      Extend.buttons.render(
          '#extend-offer',
          { referenceId: variantID }
      );
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutationRecord) {
            if ($('.extend-product-offer').html().length < 1){
              $('.pdp__extendWrapper').removeClass('pdp__extendWrapper--rendered');
            }
        });    
      });

      // Extend.buttons.render() is async - the .extend-product-offer node it
      // creates may not exist yet on the very next line. Guard against that
      // instead of letting MutationObserver.observe() throw on a null target.
      var target = document.querySelector('.extend-product-offer');
      if (target) {
        observer.observe(target, { attributes : true, attributeFilter : ['style'] });
      } else {
        console.warn('Extend: .extend-product-offer not found yet, skipping observer for this render.');
      }
    } catch (err) {
      // Never let a Extend/protection-plan failure take down the rest of
      // this ready handler (add to cart, nav, etc. are bound after this).
      console.warn('Extend: renderExtend() failed, continuing without the protection plan widget.', err);
    }
  }

  function initExtendWhenReady(retriesLeft){
    if (typeof retriesLeft === 'undefined') { retriesLeft = 50; } // ~5s at 100ms intervals
    if (!$('#extend-offer').length) { return; }
    // Extend.config({ storeId }) runs in its own DOMContentLoaded listener
    // elsewhere on the page and is not guaranteed to run before this jQuery
    // ready handler. Poll briefly instead of assuming Extend is ready.
    if (typeof Extend !== 'undefined' && Extend.buttons && typeof Extend.buttons.render === 'function') {
      renderExtend();
      extendRendered = true;
      return;
    }
    if (retriesLeft <= 0) {
      console.warn('Extend: SDK never became ready, skipping protection plan widget on this PDP.');
      return;
    }
    setTimeout(function(){ initExtendWhenReady(retriesLeft - 1); }, 100);
  }
  initExtendWhenReady();
  

  function changeExtend(){
    try {
      console.log('change extend');
      var variantID = $('[sm-rc-variant-selector]').find(":selected").attr('value');
      Extend.setActiveProduct('#extend-offer', variantID);
    } catch (err) {
      console.warn('Extend: changeExtend() failed.', err);
    }
  }

  function updateLineItemCartPage(key, newQty){
    var update = {
      id: key,
      quantity: newQty
    };

    jQuery.ajax({
      type:'post',
      url:'/cart/change.js',
      data:update,
      dataType:'json',
      success:function(result){
        console.log(result);
        onCartChangeCartPage();
      },
      error:function(result){
        console.error(result);
      }
    });
  }

  function onCartChangeCartPage(){
    getCartData().then(
      function(value) {
        cartData = { ...value }; //shallow copy
        console.log(cartData);
        //what to do with new cart content goes here
        var subtotal = cartData.items_subtotal_price;
    
        $('.newCart__summaryRow--subtotal .newCart__summaryValue').text(formatPrice(subtotal));
        $('.newCart__summaryRow--estimatedTotal .newCart__summaryValue').text(formatPrice(subtotal));
        $('.newCart__affirm .affirm-as-low-as').attr('data-amount', subtotal);
        affirm.ui.refresh();
      }
    );
  }

  $('.newItem__qtyMinus').on('click', function(){
    var card = $(this).closest('.newItem');
    var key = card.attr('data-index');
    var oldQty = card.find('.newItem__qtyWrapper input').val() * 1;
    var newQty = oldQty - 1;
    if (newQty > 0){
      card.find('.newItem__qtyWrapper input').val(newQty);
      updateLineItemCartPage(key, newQty);
      
    }
  });
  
  $('.newItem__qtyPlus').on('click', function(){
    var card = $(this).closest('.newItem');
    var key = card.attr('data-index');
    var oldQty = card.find('.newItem__qtyWrapper input').val() * 1;
    var newQty = oldQty + 1;

    card.find('.newItem__qtyWrapper input').val(newQty);
    updateLineItemCartPage(key, newQty);

  });
  
  $('.newItem__removeFromCart').on('click', function(){
    var card = $(this).closest('.newItem');
    var key = card.attr('data-index');
    var oldQty = card.find('.newItem__qtyWrapper input').val() * 1;
    var newQty = 0;

    card.slideUp();
    updateLineItemCartPage(key, newQty)
  });

  if ($('.accountSBS__loading').length){
    var hash = window.location.hash.substring(1);
    console.log(hash)
    if (hash == "recover"){
      $('.accountSBS__resetWrapper').show();
    }
    else{
      $('.accountSBS__loginWrapper').show();
    }
    $('.accountSBS__loading').hide();
  }
  
  $('.accountSBS__recover').on('click', function(){
    $('.accountSBS__loginWrapper').hide();
    $('.accountSBS__resetWrapper').show();
  });

  $('.accountSBS__login').on('click', function(){
    $('.accountSBS__resetWrapper').hide();
    $('.accountSBS__loginWrapper').show();
  });

  $('.blogBody__loadMore').on('click', function(){
    $('.articleCard--unloaded').removeClass('articleCard--unloaded');
    $('.blogBody__loadMoreRow').hide();
  });

  $('.articleNew__content p').each(function(){
    if ($(this).find('img').length > 1){
      $(this).addClass('articleNew__imageSBS');
    }
  });

  $("nav.adBanner__navWrapper").accessibleMegaMenu({
        /* prefix for generated unique id attributes, which are required 
           to indicate aria-owns, aria-controls and aria-labelledby */
        uuidPrefix: "accessible-megamenu",

        /* css class used to define the megamenu styling */
        menuClass: "nav-menu",

        /* css class for a top-level navigation item in the megamenu */
        topNavItemClass: "nav-item",

        /* css class for a megamenu panel */
        panelClass: "sub-nav",

        /* css class for a group of items within a megamenu panel */
        panelGroupClass: "sub-nav-group",

        /* css class for the hover state */
        hoverClass: "hover",

        /* css class for the focus state */
        focusClass: "focus",

        /* css class for the open state */
        openClass: "open"
    });

  $("nav.headerNew__navWrapper").accessibleMegaMenu({
        /* prefix for generated unique id attributes, which are required 
           to indicate aria-owns, aria-controls and aria-labelledby */
        uuidPrefix: "accessible-megamenu",

        /* css class used to define the megamenu styling */
        menuClass: "nav-menu",

        /* css class for a top-level navigation item in the megamenu */
        topNavItemClass: "nav-item",

        /* css class for a megamenu panel */
        panelClass: "sub-nav",

        /* css class for a group of items within a megamenu panel */
        panelGroupClass: "sub-nav-group",

        /* css class for the hover state */
        hoverClass: "hover",

        /* css class for the focus state */
        focusClass: "focus",

        /* css class for the open state */
        openClass: "open"
    });

  var lastScrollTop = $(window).scrollTop();
  $(window).on('scroll resize', function () {
    if ($(window).scrollTop() > 40) {
      
      $('body').addClass('body--scrolled');
    } else {

      $('body').removeClass('body--scrolled');
    }

    if ($(window).scrollTop() > lastScrollTop) {
      $('body').removeClass('body--scrolledUp');
    } else {
      $('body').addClass('body--scrolledUp');
    }
    lastScrollTop = $(window).scrollTop();
  });

  var keyboardUser = false;

  document.onkeydown = (e) => {
      if(e.keyCode === 9) {
        keyboardUser = true;
      }
  }

  $('.headerNew__searchButton').on('click', function(e){
    if (keyboardUser == true){
      
    }
    else{
      e.preventDefault();
      if ($('.newSearchPopup').is(':visible')){
        $('.newSearchPopup').hide();
      }
      else{
        $('.newSearchPopup').show();
      }
      
    }
  });

  $('.mobNav__lowerLinkWrapper--retailer').find('.mobNav__lowerLink').attr('href', $('.adBanner__retailer').attr('href') );
  $('.mobNav__lowerLinkWrapper--retailer').find('.mobNav__linkText').text($('.adBanner__retailer').find('.adBanner__linkText').text());

  $('.mobNav__menuItemOuterContainer--lower .mobNav__subMenuNav').html($('.adBanner .megaMenu__columnWrapper').html());
  
  $('.headerNew__hamburger').on('click', function(){
    if ($(this).hasClass('headerNew__hamburger--open')){
      $('body, html').removeClass('noScroll');
      // $('.mobNav').hide();
      $('.mobNav').removeClass('open');
      $(this).removeClass('headerNew__hamburger--open');
    }
    else{
      $('body, html').addClass('noScroll');
      // $('.mobNav').show();
      $('.mobNav').addClass('open');
      $(this).addClass('headerNew__hamburger--open');
    }
  });

  $('.mobNav__closeButton').on('click', function(){
    $('body, html').removeClass('noScroll');
    $('.mobNav').removeClass('open');
    $('.headerNew__hamburger').removeClass('headerNew__hamburger--open');
  });

  $('.mobNav__menuItemHeader').on('click', function(){
    $(this).parent().addClass('mobNav__menuItemOuterContainer--open');
    $('.mobNav__overflow').addClass('noScroll');
  });
  $('.mobNav__subMenuBackButton').on('click', function(){
    $(this).closest('.mobNav__menuItemOuterContainer').removeClass('mobNav__menuItemOuterContainer--open')
    $('.mobNav__overflow').removeClass('noScroll');
  });

  $('.blogSlider').each(function(){
    // Removed fixed height to improve accessibility - allows content to expand naturally with text spacing tools
    //var fixedHeight = $(this).find('.articleCard').first().height();
    //$(this).find('.articleCard .articleCard__link').attr('style', "height:"+fixedHeight+"px!important;");

    $(this).find('.articleCard .articleCard__link').attr('style', "height: auto !important;");
  });

  $('.newCard__discountCodeInput').on('keyup', function(){
    var discount = $(this).val();
    $('.newCart__checkout').attr('href', '/checkout?discount='+discount);
  });


  $('.megaMenu__overlay').on('click', function(){
    $('.megaMenu.open, .headerNew__help.open, .adBanner__help.open').removeClass('open');
  });


  $('.pdpFeatured__inner').each(function() {
    var $wrapper = $(this);
    var $img = $wrapper.find('.pdpFeatured__image');
    var isZoomed = false;
    var scale = 2; // fixed zoom factor

    // Helper: update the transform based on fraction
    // fractionX = 0 => show left edge
    // fractionX = 1 => show right edge
    // fractionY = 0 => show top edge
    // fractionY = 1 => show bottom edge
    function updateTransform(fractionX, fractionY) {
      // Wrapper's width/height
      var wWidth = $wrapper.width();
      var wHeight = $wrapper.height();

      // The image is scaled by "scale".
      // Extra width = (scale - 1) * wWidth
      // Extra height = (scale - 1) * wHeight
      // If fractionX = 0 => offsetX = 0 (left edge aligned)
      // If fractionX = 1 => offsetX = -extraWidth (right edge aligned)
      var offsetX = -(fractionX * (scale - 1) * wWidth);
      var offsetY = -(fractionY * (scale - 1) * wHeight);

      // Apply translate + scale
      $img.css('transform', 
        'translate(' + offsetX + 'px,' + offsetY + 'px) scale(' + scale + ')'
      );
    }

    // Zoom out function (shared by second click & mouseleave)
    function zoomOut() {
      $img.removeClass('zoomed');
      // Reset transform to no scale / no offset
      $img.css('transform', 'translate(0,0) scale(1)');
      isZoomed = false;
    }

    // 1) CLICK => Toggle zoom
    $wrapper.on('click', function(e) {
      if (!isZoomed) {
        isZoomed = true;
        $img.addClass('zoomed');

        // Figure out where in the wrapper the user clicked, as fraction [0..1]
        var wrapperOffset = $wrapper.offset();
        var clickX = e.pageX - wrapperOffset.left;
        var clickY = e.pageY - wrapperOffset.top;
        var fractionX = clickX / $wrapper.width();
        var fractionY = clickY / $wrapper.height();

        // Immediately position the image so that the clicked point is
        // aligned with the corresponding fraction in the zoomed image.
        updateTransform(fractionX, fractionY);

      } else {
        // If already zoomed, clicking again => zoom out
        zoomOut();
      }
    });

    // 2) MOUSEMOVE => update transform if zoomed
    $wrapper.on('mousemove', function(e) {
      if (isZoomed) {
        var wrapperOffset = $wrapper.offset();
        var mouseX = e.pageX - wrapperOffset.left;
        var mouseY = e.pageY - wrapperOffset.top;

        // Keep them within [0..1], in case the mouse is near edges
        var fractionX = mouseX / $wrapper.width();
        var fractionY = mouseY / $wrapper.height();

        // Constrain fraction to 0..1 just in case
        if (fractionX < 0) fractionX = 0;
        if (fractionX > 1) fractionX = 1;
        if (fractionY < 0) fractionY = 0;
        if (fractionY > 1) fractionY = 1;

        updateTransform(fractionX, fractionY);
      }
    });

    // 3) MOUSELEAVE => zoom out if currently zoomed
    $wrapper.on('mouseleave', function() {
      if (isZoomed) {
        zoomOut();
      }
    });

  });

  function setSolidHeader(){
      console.log('set Solid Header');
      var target = $('[data-builder-index]').first();
      var solid = false;
      var solidList = [
        'ctaButtonOnly',
        'newCart',
        'sbsSpecs',
        'ambText',
        'blogBody',
        'blogSlider',
        'blogSlider--collections',
        'twoUp',
        'buildFaq',
        'featsBlade',
        'fullText',
        'cardDisplay',
        'oneColumnAccord',
        'pdp',
        'prodRec',
        'quickStats',
        'threeCards',
        'threeCopy',
        'threeUp',
        'twoColumnAccord'        
      ]
      for (i=0;i<solidList.length;i++){
        console.log(solidList[i]);
        if (target.hasClass(solidList[i])){
          solid = true;
        }
      }
      
      if (solid){
        $('body').addClass('body--solidPage');
        $('main').addClass('marginAdd');
      }
    }
    setSolidHeader();

  function successState() {
    var prodID = $('select[sm-rc-variant-selector]').val();
    var prodQty = $('input[sm-rc-quantity-selector]').val();
    var prodPlan = $('select[sm-rc-plan-selector]').val();

    setTimeout(function () {
      jQuery.getJSON('/cart.js', function (cart) {
        $('#cart-notification').addClass('active');
        if ($('.pdp__addButton').prop('disabled') == true){
          resetAddToCartButtonAfterError();
        }
      });
    }, 200);
  }

  
  /* =========================================================
   ORIGINAL WORKING CODE + MINIMAL FIX
   Goal:
   - If a permutation DOES NOT EXIST in the variant <select>, treat it as unavailable
   - Easiest + safest: disable add-to-cart + show Sold Out state (no DOM guessing)
   - Optional (very small): hide invalid option2 choices when color changes (only if option2 is a <select>)
   ========================================================= */

  var matchString = false;

  function getMatchString() {
    var matchStringArray = [];
    if ($('[sm-rc-option1-selector]').length){
      matchStringArray.push($('[sm-rc-option1-selector]').val());
    }
    if ($('[sm-rc-option2-selector]').length){
      matchStringArray.push($('[sm-rc-option2-selector]').val());
    }
    if ($('[sm-rc-option3-selector]').length){
      matchStringArray.push($('[sm-rc-option3-selector]').val());
    }
    if (matchStringArray.length){
      matchString = matchStringArray.join(' / ');
    }
    else{
      matchString = false;
    }
  }
  getMatchString();

  function getVariantOptionByTitle(title){
    title = (title || '').trim();
    if (!title) return $();
    return $('[sm-rc-variant-selector]').find('[data-title="' + title + '"]');
  }

  function setUnavailableUI(){
    $('[sm-rc-add-to-cart]').prop('disabled', true);
    $('[sm-rc-add-to-cart]').find('.product__addButtonText').text('Sold Out');
    $('.oos-text').show();
    $('.is-text').hide();
    $('.pdp__notifyMeWrapper').show();
  }


  function hideInvalidOption2ForSelectedColor(){
    if (!$('[sm-rc-option1-selector]').length || !$('[sm-rc-option2-selector]').length) return;
    if (!$('[sm-rc-option2-selector]').is('select')) return;

    var selectedColor = String($('[sm-rc-option1-selector]').val() || '').trim();
    if (!selectedColor) return;

    var valid = {};
    $('[sm-rc-variant-selector] option').each(function(){
      var o1 = String($(this).attr('data-option-1') || '').trim();
      var o2 = String($(this).attr('data-option-2') || '').trim();
      if (o1 === selectedColor && o2) valid[o2] = true;
    });

    var $sel = $('[sm-rc-option2-selector]');
    $sel.find('option').each(function(){
      var $opt = $(this);
      var v = String($opt.val() || $opt.text() || '').trim();
      if (v && !valid[v]) {
        $opt.prop('disabled', true).hide();
      } else {
        $opt.prop('disabled', false).show();
      }
    });

    // if current selection is now invalid, choose first valid
    var cur = String($sel.val() || '').trim();
    if (cur && !valid[cur]) {
      var $first = $sel.find('option:visible:not(:disabled)').first();
      if ($first.length) $sel.val($first.val()).trigger('change');
    }
  }



  function setCurrentVariant(){
    getMatchString();

    if (matchString){
      console.log(matchString);

      var $variantOpt = getVariantOptionByTitle(matchString);


      if (!$variantOpt.length) {
        console.log('Non-existent variant combo:', matchString);
        setUnavailableUI();
        return;
      }

      var newVal = $variantOpt.val();
      $variantOpt.prop('selected', true);
      $('[sm-rc-variant-selector]').val(newVal).trigger('change');

      console.log($('[sm-rc-variant-selector]').val());
      console.log($('[sm-rc-variant-selector]').find(":selected").attr('value'));
    }
  }


  $('[sm-rc-option1-selector], [sm-rc-option2-selector], [sm-rc-option3-selector]').on('change', function(){

    if ($(this).is('[sm-rc-option1-selector]')) {
      hideInvalidOption2ForSelectedColor();
    }

    setCurrentVariant();
  });



  var currentVariant = {
    "title":"",
    "id":"",
    "available":"",
    "price":"",
    "compare_price":""
  };

  function getCurrentVariant(){
    var value = $('[sm-rc-variant-selector]').val();
    var target = $('[sm-rc-variant-selector]').find('[value="'+value+'"]');
    currentVariant.title = target.attr('data-title');
    currentVariant.id = target.attr('value');
    currentVariant.available = target.attr('data-available');
    currentVariant.price = target.attr('data-price');
    currentVariant.compare_price = target.attr('data-compare-price');
    currentVariant.img_url = target.attr('data-image');

    //setVariantParam( value );
  }
  getCurrentVariant();

  const LOCK_NUMBER_MIN_LENGTH = 4;

  function isLockNumberRequired() {
    return $('.pdp__lockWrapper').length > 0;
  }

  function isLockNumberValid() {
    if (!isLockNumberRequired()) return true;
    const $input = $('.pdpLockInput');
    if (!$input.length) return false;
    return ($input.val() || '').trim().length >= LOCK_NUMBER_MIN_LENGTH;
  }

  function updateLockAddToCartState() {
    if (!isLockNumberRequired()) return;
    if (currentVariant.available == 'false') {
      $('[sm-rc-add-to-cart]').prop('disabled', true);
      return;
    }
    $('[sm-rc-add-to-cart]').prop('disabled', !isLockNumberValid());
  }

  function resetAddToCartButtonAfterError() {
    if (isLockNumberRequired()) {
      updateLockAddToCartState();
    } else {
      $('.pdp__addButton').prop('disabled', false);
    }
    $('.pdp__addButtonText').text('Add to Cart');
  }

  function getLockCartProperties() {
    if (!$('.pdpLockInput').length || !isLockNumberValid()) return {};
    return { lockNumber: $('.pdpLockInput').val().trim() };
  }

  function showLockNumberError() {
    const $input = $('.pdpLockInput');
    if (!$input.length) return;
    $input.addClass('pdpLockInput--error').attr('aria-invalid', 'true');
    $('.pdp__lockError').prop('hidden', false);
    $input.focus();
  }

  function clearLockNumberError() {
    if (!isLockNumberValid()) return;
    $('.pdpLockInput').removeClass('pdpLockInput--error').attr('aria-invalid', 'false');
    $('.pdp__lockError').prop('hidden', true);
  }

  function renderVariables(){
    getCurrentVariant();

    var currentVariantTitle = currentVariant.title;

    var oneTimePrice = currentVariant.price;
    var currentPrice = oneTimePrice;
    var comparePrice = currentVariant.compare_price;

    var rawPrice = (currentVariant.price).replace('$', '') * 100;

    var image = currentVariant.img_url;

    // setVarImg( image );

    $('[sm-rc-current-price]').text(currentPrice);
    $('[sm-rc-compare-price]').text(comparePrice);
    $('[sm-rc-current-variant-title]').text(currentVariantTitle);

    console.log(rawPrice);
    $('.pdp__affirmWrapper .affirm-as-low-as').attr('data-amount', rawPrice);
    if (typeof affirm.ui.refresh === 'function') {
      affirm.ui.refresh();
    }

    if (currentVariant.available == 'false'){
      $('[sm-rc-add-to-cart]').prop('disabled', true);
      $('[sm-rc-add-to-cart]').find('.product__addButtonText').text('Sold Out');
      $('.oos-text').show();
      $('.is-text').hide();
      $('.pdp__notifyMeWrapper').show();
    }
    else{
      if (isLockNumberRequired()) {
        updateLockAddToCartState();
      } else {
        $('[sm-rc-add-to-cart]').prop('disabled', false);
      }
      $('[sm-rc-add-to-cart]').find('.product__addButtonText').text('Add to bag');
      $('.oos-text').hide();
      $('.is-text').show();
      $('.pdp__notifyMeWrapper').hide();
    }

    $('.pdp__notifyMeButton').attr('variant-id', currentVariant.id);
  }

  if ($('[sm-rc-current-price]').length > 0){
    renderVariables();
  }

  $('[sm-rc-variant-selector], [sm-rc-plan-selector]').on('change', function(){
    renderVariables();
  });

  $('.pdpLockInput').on('input', function(){
    clearLockNumberError();
    if (currentVariant.available != 'false') {
      updateLockAddToCartState();
    }
  });

  $('[sm-rc-add-to-cart]').on('click', function(){
    console.log('clicked add to cart button');

    if ($('.pdpLockInput').length && !isLockNumberValid()) {
      showLockNumberError();
      return false;
    }

    $('.pdp__addButton').prop('disabled', true);
    $('.pdp__addButtonText').text('Adding To Cart...');

    var qty = $('[sm-rc-quantity-selector]').val();

    // Extend.buttons.instance() only returns a usable component if Extend
    // finished initializing for this container. Don't assume it did - the
    // Extend SDK configures itself asynchronously and can still be mid-race
    // when this click fires.
    var extendComponent = null;
    if ($('#extend-offer').length && typeof Extend !== 'undefined' && Extend.buttons && typeof Extend.buttons.instance === 'function') {
      try {
        extendComponent = Extend.buttons.instance('#extend-offer');
      } catch (err) {
        console.warn('Extend: buttons.instance() failed, adding to cart without a protection plan.', err);
        extendComponent = null;
      }
    }

    if (extendComponent){
      const component = extendComponent;
      const plan = component.getPlanSelection();
      const product = component.getActiveProduct();

      if (plan){
        ExtendShopify.addPlanToCart({ plan, product, qty }, function(){

          var props = getLockCartProperties();

          console.log('props');
          console.log(props);

          if ($('.pdp__bundleRadioButton--selected').length > 0 && $('.pdp__bundleRadioButton--selected').attr('data-id') != '0'){
            console.log('bundle product being added');
            var prodsToAdd = [
              {
                id: parseInt(currentVariant.id),
                quantity: qty,
                properties: props
              },
              {
                id: parseInt($('.pdp__bundleRadioButton--selected').attr('data-id')),
                quantity: qty
              }
            ];

            CartJS.addItems(prodsToAdd,
            {
              "success": function(data, textStatus, jqXHR) {
                successState();
              },
              "error": function(jqXHR, textStatus, errorThrown) {
                console.log('Error: ' + errorThrown + '! - here');
                if ($('.pdp__addButton').prop('disabled') == true){
                  resetAddToCartButtonAfterError();
                }
              }
            });

          }
          else{

            CartJS.addItem(parseInt(currentVariant.id), qty, props,
            {
              "success": function(data, textStatus, jqXHR) {
                successState();
              },
              "error": function(jqXHR, textStatus, errorThrown) {
                console.log('Error: ' + errorThrown + '! - here');
                if ($('.pdp__addButton').prop('disabled') == true){
                  resetAddToCartButtonAfterError();
                }
              }
            });
          }
          
        });
      }
      else{
        Extend.modal.open({
          referenceId: parseInt(currentVariant.id),
          onClose: function(plan, product) {
            if (plan && product) {
              ExtendShopify.addPlanToCart({ plan, product, qty }, function(){

                var props = getLockCartProperties();

                console.log('props');
                console.log(props);

                console.log('plan added');

                if ($('.pdp__bundleRadioButton--selected').length > 0 && $('.pdp__bundleRadioButton--selected').attr('data-id') != '0'){
                  console.log('bundle product being added');

                  var prodsToAdd = [
                    {
                      id: parseInt(currentVariant.id),
                      quantity: qty,
                      properties: props
                    },
                    {
                      id: parseInt($('.pdp__bundleRadioButton--selected').attr('data-id')),
                      quantity: qty
                    }
                  ];

                  CartJS.addItems(prodsToAdd,
                  {
                    "success": function(data, textStatus, jqXHR) {
                      successState();
                    },
                    "error": function(jqXHR, textStatus, errorThrown) {
                      console.log('Error: ' + errorThrown + '! - here');
                      if ($('.pdp__addButton').prop('disabled') == true){
                        resetAddToCartButtonAfterError();
                      }
                    }
                  });
                }
                else{
                  CartJS.addItem(parseInt(currentVariant.id), qty, props,
                  {
                    "success": function(data, textStatus, jqXHR) {
                      successState();
                    },
                    "error": function(jqXHR, textStatus, errorThrown) {
                      console.log('Error: ' + errorThrown + '! - here');
                      if ($('.pdp__addButton').prop('disabled') == true){
                        resetAddToCartButtonAfterError();
                      }
                    }
                  });
                }
                
              });
            } else {

              var props = getLockCartProperties();

              console.log('props');
              console.log(props);

              console.log('plan not added');

              if ($('.pdp__bundleRadioButton--selected').length > 0 && $('.pdp__bundleRadioButton--selected').attr('data-id') != '0'){
                console.log('bundle product being added');

                var prodsToAdd = [
                  {
                    id: parseInt(currentVariant.id),
                    quantity: qty,
                    properties: props
                  },
                  {
                    id: parseInt($('.pdp__bundleRadioButton--selected').attr('data-id')),
                    quantity: qty
                  }
                ];

                CartJS.addItems(prodsToAdd,
                {
                  "success": function(data, textStatus, jqXHR) {
                    successState();
                  },
                  "error": function(jqXHR, textStatus, errorThrown) {
                    console.log('Error: ' + errorThrown + '! - here');
                    if ($('.pdp__addButton').prop('disabled') == true){
                      resetAddToCartButtonAfterError();
                    }
                  }
                });
              }
              else{
                CartJS.addItem(parseInt(currentVariant.id), qty, props,
                {
                  "success": function(data, textStatus, jqXHR) {
                    successState();
                  },
                  "error": function(jqXHR, textStatus, errorThrown) {
                    console.log('Error: ' + errorThrown + '! - here');
                    if ($('.pdp__addButton').prop('disabled') == true){
                      resetAddToCartButtonAfterError();
                    }
                  }
                });
              }
              
            }
          },
        })
      }
    }
    else{
      var props = getLockCartProperties();

      console.log('props');
      console.log(props);

      // This branch runs whenever Extend isn't available for this add-to-cart
      // click (no offer element, or the SDK hasn't finished initializing yet)
      // - it must not skip the bundle add just because Extend is out of the
      // picture, so it mirrors the same bundle-vs-single logic used above.
      if ($('.pdp__bundleRadioButton--selected').length > 0 && $('.pdp__bundleRadioButton--selected').attr('data-id') != '0'){
        console.log('bundle product being added');
        var prodsToAdd = [
          {
            id: parseInt(currentVariant.id),
            quantity: qty,
            properties: props
          },
          {
            id: parseInt($('.pdp__bundleRadioButton--selected').attr('data-id')),
            quantity: qty
          }
        ];

        CartJS.addItems(prodsToAdd,
        {
          "success": function(data, textStatus, jqXHR) {
            successState();
          },
          "error": function(jqXHR, textStatus, errorThrown) {
            console.log('Error: ' + errorThrown + '! - here');
            if ($('.pdp__addButton').prop('disabled') == true){
              resetAddToCartButtonAfterError();
            }
          }
        });
      }
      else{
        CartJS.addItem(parseInt(currentVariant.id), qty, props,
        {
          "success": function(data, textStatus, jqXHR) {
            successState();
          },
          "error": function(jqXHR, textStatus, errorThrown) {
            console.log('Error: ' + errorThrown + '! - here');
            if ($('.pdp__addButton').prop('disabled') == true){
              resetAddToCartButtonAfterError();
            }
          }
        });
      }
    }
  });

  $('.pdpMobileStickyBuy__button').on('click', function(){
    $('.pdp__addButton').click();
  });

  (function handlePDPOutOfStock(){
    if ($('.pdp__optionWrapper').length == 1 && $('.pdp__optionButton--oos').length > 0){
      var hideIndexes = [];
      $('.sm-rc-widget [sm-rc-variant-selector] option').each(function(){
        hideIndexes.push($(this).attr('data-available') === "false" ? "false" : "true");
      });
      var i = 0;
      $('.pdp__optionButton--oos').each(function(){
        if (hideIndexes[i] == "false"){
          $(this).hide();
        }
        i += 1;
      });
    }
  })();


    // ===== Config =====
  const VENDOR_MARKER = 'vn-injected';
  const VENDOR_NODE   = 'boost-sb__product-vendor';

  function formatJudgeMeReviewCount(text) {
    if (!text) return null;
    const trimmed = text.trim();
    if (/^\(\d+\)$/.test(trimmed)) return trimmed;
    const match = trimmed.match(/^(\d+)\s*reviews?$/i);
    if (match) return '(' + match[1] + ')';
    return null;
  }

  function processJudgeMeBadgeText(scope = document) {
    $(scope)
      .find('.jdgm-prev-badge__text, .jdgm-prev-badgetext')
      .each(function () {
        const text = ($(this).text() || '').trim();
        const formatted = formatJudgeMeReviewCount(text);
        if (formatted && text !== formatted) {
          $(this).text(formatted);
        }
      });
  }

  function getVendorByHandle(handle) {
    const match = (window.collectionProds || []).find(obj => obj.handle === handle);
    return match ? match.vendor : undefined;
  }

  function processNewBoostItems(scope = document) {
    const prodsReady = Array.isArray(window.collectionProds) && window.collectionProds.length > 0;

    $(scope)
      .find('.boost-sd__product-item')
      .not('.' + VENDOR_MARKER)
      .each(function () {
        const $item = $(this);

        if ($item.find('.' + VENDOR_NODE).length) {
          $item.addClass(VENDOR_MARKER);
          return;
        }

        const raw = $item.attr('data-product');
        if (!raw) return;

        let decoded;
        try { decoded = JSON.parse(raw); } catch (e) { return; }

        const handle = decoded && decoded.handle;
        if (!handle) return;

        const vendor = getVendorByHandle(handle);
        if (!vendor) {
          if (prodsReady) $item.addClass(VENDOR_MARKER);
          return;
        }

        const $title = $item.find('.boost-sd__product-title');
        if (!$title.length) return;

        $title.after('<div class="' + VENDOR_NODE + '">' + vendor + '</div>');
        $item.addClass(VENDOR_MARKER);
      });
  }

  function runCollectionCardEnhancements(scope = document) {
    processJudgeMeBadgeText(scope);
    processNewBoostItems(scope);
  }

  (function bootCollectionCardEnhancements() {
    runCollectionCardEnhancements(document);

    setInterval(function () {
      if ($('.boost-sd__product-item').length || $('.jdgm-widget').length) {
        runCollectionCardEnhancements(document);
      }
    }, 300);

    if (typeof MutationObserver !== 'undefined') {
      let debounceTimer;
      const observer = new MutationObserver(function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
          runCollectionCardEnhancements(document);
        }, 50);
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  })();

  $('header .nav-item').on('click', function(){
    $('.newSearchPopup').hide();
  });

  if (isLockNumberRequired()) {
    updateLockAddToCartState();
    setTimeout(updateLockAddToCartState, 0);
  }

});

jQuery(document).ready(function ($) {

  function formatPrice(cents) {
      return '$' + (cents / 100).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
      });
  }

  function initBundlePrices(){
    if ($('.pdp__bundleRadioButton--selected').length > 0){
      // Start from the pre-selected tile (usually the included one, but it can be
      // another tile when the included item is sold out or a tile is set as the default).
      var $initial = $('.pdp__bundleRadioButton--selected').first();
      var includedPrice = $initial.attr('data-price') * 1;
      // Use the selected bundle item's own compare-at price (not its sale price) so the
      // combined "was" price reflects each item's real markdown, matching how the current
      // price uses each item's sale price. Falls back to data-price if data-compare-price
      // isn't present (e.g. on a theme version before this attribute was added).
      var includedComparePriceAttr = $initial.attr('data-compare-price');
      var includedComparePrice = (typeof includedComparePriceAttr !== 'undefined') ? (includedComparePriceAttr * 1) : includedPrice;
      var basePrice = $('[sm-rc-current-price]').first().text().replace('$', '').replace(',', '').replace('.', '') * 1;
      $('[sm-rc-current-price]').attr('data-initial-price', basePrice);
      var comparePrice = $('[sm-rc-compare-price]').first().text().replace('$', '').replace(',', '').replace('.', '') * 1;
      $('[sm-rc-compare-price]').attr('data-initial-price', comparePrice);

      var combinedPrice = includedPrice + basePrice;
      $('[sm-rc-current-price]').text(formatPrice(combinedPrice));

      var combinedCompare = includedComparePrice + comparePrice;
      $('[sm-rc-compare-price]').text(formatPrice(combinedCompare));

      var selectionName = $('.pdp__bundleRadioButton--selected').attr('data-name');
      $('.pdp__bundleSelectedName').text(selectionName);
    }
  }
  initBundlePrices();


  function calculateBundlePrices(){
    if ($('.pdp__bundleRadioButton--selected').length > 0){
      $('.pdp__bundleRadioButton').each(function(){
        var includedPrice = $('.pdp__bundleRadioButton--included').attr('data-price') * 1;
        var thisPrice = $(this).attr('data-price') * 1;
        var difference = thisPrice - includedPrice;

        var priceDiffText = '';
        if (difference > 0){
          priceDiffText = '(+' + formatPrice(difference) + ')';
        }
        else{
          priceDiffText = '(-' + formatPrice(Math.abs(difference)) + ')';
        }
        if (!$(this).hasClass('pdp__bundleRadioButton--included')){
          $(this).find('.pdp__bundleRadioButtonPrice').text(priceDiffText);
        }
        
      });
    }
  }
  calculateBundlePrices();

  $('.pdp__bundleRadioButton').on('click', function(){
    $('.pdp__bundleRadioButton').removeClass('pdp__bundleRadioButton--selected');
    $(this).addClass('pdp__bundleRadioButton--selected');
    var selectionName = $(this).attr('data-name');
    $('.pdp__bundleSelectedName').text(selectionName);

    var selectedPrice = $(this).attr('data-price') * 1;
    // Same fix as initBundlePrices(): the compare-at math needs the selected item's own
    // compare-at price, not its sale price, or the "was" price undercounts the markdown.
    var selectedComparePriceAttr = $(this).attr('data-compare-price');
    var selectedComparePrice = (typeof selectedComparePriceAttr !== 'undefined') ? (selectedComparePriceAttr * 1) : selectedPrice;
    var basePrice = $('[sm-rc-current-price]').attr('data-initial-price') * 1;
    var comparePrice = $('[sm-rc-compare-price]').attr('data-initial-price') * 1;

    var combinedPrice = selectedPrice + basePrice;
    $('[sm-rc-current-price]').text(formatPrice(combinedPrice));

    var combinedCompare = selectedComparePrice + comparePrice;
    $('[sm-rc-compare-price]').text(formatPrice(combinedCompare));

    if ($(this).attr('data-in-stock') == "false"){
      $('[sm-rc-add-to-cart]').prop('disabled', true);
      $('.oos-text').show();
      $('.is-text').hide();
      $('.pdp__notifyMeWrapper').show();
    }
    else{
      if ($('.pdp__lockWrapper').length) {
        $('[sm-rc-add-to-cart]').prop('disabled', ($('.pdpLockInput').val() || '').trim().length < 4);
      } else {
        $('[sm-rc-add-to-cart]').prop('disabled', false);
      }
      $('.oos-text').hide();
      $('.is-text').show();
      $('.pdp__notifyMeWrapper').hide();
    }
    
  });

  $('.pdp__bundleRadioButton--selected').click();
  
});